'use client';

import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

interface QueryProviderProps {
  children: React.ReactNode;
}

// https://tanstack.com/query/v4/docs/react/guides/ssr#using-the-app-directory-in-nextjs-13
export const QueryProvider = (props: QueryProviderProps) => {
  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        // queries: {
        //   staleTime: 5000,
        // },
      },
    })
  );

  return <QueryClientProvider client={client}>{props.children}</QueryClientProvider>;
};
